var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CheckButton',{attrs:{"waiting":_vm.waitGetDone,"lite":_vm.lite,"disabled":_vm.disabled},model:{value:(_vm.isDone),callback:function ($$v) {_vm.isDone=$$v},expression:"isDone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }